import React from 'react';
import PropTypes from 'prop-types';

import Menu from '../Menu/Menu';

import { PageWithMenuStyle } from './PageWithMenuStyle';

const PageWithMenu = ({ children, menuStyle, showMenu, examSummary, exportExamsToCSV }) => {
  return (
    <PageWithMenuStyle>
      <div className="menu-area">
        <Menu show={showMenu} style={menuStyle} examSummary={examSummary} exportExamsToCSV={exportExamsToCSV} />
      </div>
      <div className="content-area">{children}</div>
    </PageWithMenuStyle>
  );
};

PageWithMenu.propTypes = {
  children: PropTypes.node.isRequired,
  menuStyle: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.objectOf(PropTypes.string),
  ]),
  examSummary: PropTypes.any,
  exportExamsToCSV: PropTypes.func,
  showMenu: PropTypes.bool,
};

PageWithMenu.defaultProps = {
  showMenu: false,
  menuStyle: null,
  examSummary: null,
};

export default PageWithMenu;
